// extracted by mini-css-extract-plugin
export default {"app-loader-logo":"AppLoader_app-loader-logo__tCe7Z","fadein":"AppLoader_fadein__A5spB"};